export default {
    'add-new-visit': 'Add new visit',
    'message': 'Sorry, there is no plan created by the medical rep',
    'there-is-no-plan-created-for-the-selected-month': 'Sorry, there is no plan created for the selected month',
    'this-visit': 'this visit'
}